declare module '@df/core/service/df-event' {
    interface IEventType {
        /**
         * Trigger when dialog is opened or closed
         */
        dialogOpenEvent: DfEventConfig<'dialogEvent', DialogEvent, void>;
    }
}

export class DialogEvent {
    constructor(
        public type: DialogEventType,
        public id: string
    ) {}
}

export type DialogPosition = 'left' | 'right' | 'center';

export const DIALOG_EVENT = 'dialogEvent';

export enum DialogEventType {
    Open = 'open',
    Close = 'close'
}
